import http from "@/plugins/http"
import fieldType from "@/enums/fieldType"
import states from "@/enums/states"
import Messenger from "@/plugins/Messenger"

export default {
    data() {
        return {
            document: {},
            schema: null,
            fields: [],
            workers: [],
            formName: "",
            payload: {
                results: [],
                related_value_id: null,
                schema_id: null
            },
            loading: false,
            clickedField: null,
            clickedInput: null,
            infinityDate: true,
            recognizedText: null,
            onFinish: () => null,
            schemas: false,
            states: states,
            relatedValues: [],
            firstLoading: true
        }
    },
    methods: {
        validatePayloadData() {
            if ((!this.payload.expiration_date && !this.infinityDate) || !this.payload.document_date) {
                Messenger.emitError("Data dokumentu oraz jego ważńość musi byc ustawiona")
                return false
            }

            if (this.payload.worker_guid == undefined) {
                Messenger.emitError("Błąd - Musisz wybrać pracownika")
                return false
            }

            return true
        },
        filterWorkers(worker, text) {
            return (worker.name + ' ' + worker.surname).toLowerCase().includes(text.toLowerCase()) ||
                worker.pesel.toString().includes(text)
        },
        textRecognized(event) {
            this.recognizedText = event.data
            this.onFinish = event.onFinish
            this.setDataOnFields()
        },
        fieldClicked(e, field) {
            if (this.clickedField) {
                e.target.style['border-left'] = ''
                e.target.style['border-right'] = ''
                e.target.style['border-bottom'] = ''
            }

            if (e.target.nodeName != "INPUT") {
                return
            }
            this.clickedField = field
            this.clickedInput = e.target
            e.target.style['border-left'] = '2px solid green'
            e.target.style['border-right'] = '2px solid green'
            e.target.style['border-bottom'] = '2px solid green'
            this.setDataOnFields()
        },
        setDataOnFields() {
            if (!this.clickedInput || !this.recognizedText) {
                return
            }
            this.fixRecognizedData()
            this.setValue(this.recognizedText, this.clickedField.order)
            this.$refs[`field_${this.clickedField.order}`][0].model = this.recognizedText
            this.onFinish()
            this.cleanAfterDataSet()
        },
        fixRecognizedData() {
            if (this.clickedField.type == 'date') {
                this.recognizedText = this.getOcrFixedDate(this.recognizedText)
            }
        },
        cleanAfterDataSet() {
            this.clickedInput.style.border = ''
            this.clickedField = this.clickedInput = this.recognizedText = null
        },
        getInputComponent(type) {
            return type + "-input"
        },
        getFieldInfo(id) {
            return this.fields.find(field => field.id == id)
        },
        getFieldByOrder(order) {
            return this.fields.find(field => field.order == order)
        },
        getFieldValue(id) {
            let field = this.getFieldInfo(id)
            if (!field) return undefined

            let cell = this.payload.results.find(cell => cell.order == field.order)
            if (cell) {
                return cell.value
            }
        },
        getValue(order) {
            let cell = this.payload.results.find(cell => cell.order == order)
            if (cell) {
                return cell.value
            }
            return ''

        },
        setValue(value, order) {
            let cell = this.payload.results.find(cell => cell.order == order)
            if (cell) {
                cell.value = value
            } else {
                this.payload.results.push({
                    order,
                    value
                })
            }
        },
        getOcrFixedDate(value) {
            if (!value) {
                return ""
            }

            let dateVal = value.match(/\d{2}\.\d{2}\.\d{4}/)
            if (dateVal) {
                return dateVal[0].split('.').reverse().join('-')
            }
            dateVal = value.match(/\d{4}\.\d{2}\.\d{2}/)
            return dateVal ? dateVal[0].split('.').join('-') : ""
        },
        getOcrFixedValue(res) {
            let field = this.getFieldByOrder(res.order)
            return (field && field.type == 'date') ? this.getOcrFixedDate(res.value) : res.value

        },
        changeSchema(idSchema) {
            this.loading = true
            let schema = http.get('schema/' + idSchema)
            //let form = http.get('document/' + this.document.id + '/schema/' + idSchema + '/ocr/mock-form')
            this.fields = []
            Promise.all([schema]).then(data => {
                this.schema = data[0].data
                this.fields = data[0].data.fields.filter(field => !fieldType.hidden.includes(field.type))
                this.formName = data[0].data.name

                // this.payload.results = data[1].data.results.map(res => ({
                //         order: res.order,
                //         value: this.getOcrFixedValue(res)
                //     })
                // )
                this.payload.schema_id = parseInt(idSchema)
                this.loading = false
            }).catch(() => Messenger.emitError("Problem ze zmianą dokumentu"))
        },
        loadSchemas() {
            this.loading = true
            http.get(`/schemas`).then(data => {
                this.schemas = data.data
                this.loading = false
            }).catch(() => Messenger.emitError("Problem z załadowaniem schematów"))
        },
        loadWorkers() {
            this.loading = true
            http.get(`/document/workers`).then(data => {
                this.workers = data.data
                this.loading = false
            }).catch(() => Messenger.emitError("Problem z załadowaniem pracowników"))
        },
        loadRelatedValues() {
            http.get(`/related/schema/${this.document.related_schema_id}/values`).then(data => {
                this.relatedValues = data.data
                this.payload.related_value_id = parseInt(this.document.related_value_id)
            })
        },
        notUpdateField(field) {
            return !fieldType.notUpdate.includes(field.type)
        },
    }
}